/**
 * Licensed to the Apache Software Foundation (ASF) under one or more
 * contributor license agreements.  See the NOTICE file distributed with
 * this work for additional information regarding copyright ownership.
 * The ASF licenses this file to You under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with
 * the License.  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as service from '@/store/modules/dashboard/fragments/service';
import * as endpoint from '@/store/modules/dashboard/fragments/endpoint';
import * as instance from '@/store/modules/dashboard/fragments/instance';
import * as database from '@/store/modules/dashboard/fragments/database';
import * as dependency from '../fragments/comparison';

export default {
  ...service,
  ...endpoint,
  ...instance,
  ...database,
  ...dependency,
};
